import { Angulartics2 } from '../angulartics';
import { useContext } from 'react';
import { uuidv4 } from '../../core/utils/uuid';
import useService from '../../injector/hooks/useService';
import { AnalyticsContext } from '../context/AnalyticsContext';

export default function useAnalyticsTracker() {
  const angulartics2 = useService(Angulartics2);

  const { sessionId, updateSessionId } = useContext(AnalyticsContext);

  return {
    eventTrack: (data: { action: string; properties?: any }) => {
      let { properties = {} } = data;
      if (sessionId) {
        properties = {
          sessionId,
          ...properties
        };
      }
      angulartics2.eventTrack.next({
        action: data.action,
        properties
      });
    },
    startSession: () => {
      updateSessionId(uuidv4());
    },
    endSession: () => {
      updateSessionId(null);
    }
  };
}
